import { CONTACTO_GENERAL, CONTACTO_PQR } from "@/components/Contactanos";
import { URL_ROGE } from "@/lib/dominio";

export { URL_ROGE };

// Textos según los permisos reales de cada rol (auth.PERMISSIONS en el servidor).
export const PERFILES = {
  admin: {
    label: "Administrador",
    funciones: "Como administrador podrás gestionar empleados y expedientes, contrataciones y firmas, plantillas oficiales, certificados laborales, el Reglamento Interno de Trabajo, la importación de la matriz Excel, los usuarios y la configuración de la plataforma.",
    paso: "Tu primer paso: crea tu contraseña con el enlace. Al ingresar, Roge te guiará para activar la verificación en dos pasos con una app gratuita como Google Authenticator o Microsoft Authenticator: escanearás un código QR y guardarás tus códigos de recuperación en un lugar seguro.",
  },
  gestor: {
    label: "Gestor",
    funciones: "Como gestor podrás consultar y actualizar empleados y expedientes, validar documentos, preparar contrataciones y firmas, cargar soportes de afiliación, expedir certificados laborales y consultar el Reglamento Interno de Trabajo.",
    paso: "Tu primer paso: crea tu contraseña con el enlace y revisa la sección «Expedientes» para ver qué documentos están listos para validar.",
  },
  importador: {
    label: "Importador",
    funciones: "Como importador podrás cargar y exportar la matriz Excel oficial de empleados y consultar la información importada.",
    paso: "Tu primer paso: crea tu contraseña con el enlace y entra a «Importaciones» para cargar la matriz.",
  },
  visor: {
    label: "Visor (solo lectura)",
    funciones: "Como visor podrás consultar, sin modificar, la información de las empresas usuarias que HUMAN te asignó: empleados, expedientes, contrataciones, terminaciones y certificados, y exportar reportes.",
    paso: "Tu primer paso: crea tu contraseña con el enlace y revisa el «Inicio» para ver el resumen de tus empresas asignadas.",
  },
  empleado: {
    label: "Empleado",
    funciones: "En tu portal podrás completar tu hoja de vida, entregar tus documentos y los de tus beneficiarios, firmar los documentos de tu contratación, consultar tus afiliaciones y certificados laborales y leer el Reglamento Interno de Trabajo.",
    paso: "Tu primer paso: crea tu contraseña con el enlace y completa «Mi hoja de vida». Después carga tus documentos en «Mis documentos» para avanzar en tu proceso.",
  },
  empresa_cliente: {
    label: "Empresa usuaria",
    funciones: "Podrás consultar los empleados de tu empresa (activos y retirados), descargar su información en Excel, generar certificados laborales, revisar sus soportes de afiliación y consultar el Reglamento Interno de Trabajo.",
    paso: "Tu primer paso: crea tu contraseña con el enlace y entra a «Mis empleados» para consultar a tu equipo.",
  },
};

export const enlaceActivacion = (token) => `${window.location.origin}/activar/${token}`;

export function mensajeRogelio({ nombre, email, role, enlace }) {
  const p = PERFILES[role] || PERFILES.empleado;
  const soporte = role === "empresa_cliente" ? CONTACTO_PQR.wa : CONTACTO_GENERAL.wa;
  const n = (nombre || "").trim();
  return [
    n ? `¡Hola, ${n}! 👋 Soy Rogelio y te doy la bienvenida a Roge by Human RMSA.` : "¡Hola! 👋 Soy Rogelio y te doy la bienvenida a Roge by Human RMSA.",
    "Estoy aquí para acompañarte y ayudarte a que cada paso sea más claro y sencillo.",
    "",
    p.funciones,
    "",
    "Estos son tus datos de acceso:",
    email ? `📧 Correo: ${email}` : null,
    enlace ? `🔐 Crea tu contraseña aquí (enlace personal de un solo uso, vence en 72 horas): ${enlace}` : "🔐 Contraseña: la que tú mismo creaste.",
    `👉 ${enlace ? "Luego ingresa aquí" : "Ingresa aquí"}: ${URL_ROGE}`,
    "",
    enlace ? p.paso : p.paso.replace("crea tu contraseña con el enlace y ", "ingresa con tu correo y tu contraseña y ").replace("crea tu contraseña con el enlace. Al ingresar,", "ingresa con tu correo y tu contraseña;"),
    enlace ? null : "¿Olvidaste tu contraseña? Escríbenos y te enviamos un enlace nuevo para crearla.",
    "",
    "Por tu seguridad, no compartas este enlace ni tus datos de acceso con nadie.",
    "",
    `Si necesitas ayuda, escríbenos por WhatsApp: ${soporte} 💬. Con gusto te acompañamos.`,
    "",
    n ? `¡Qué gusto contar contigo, ${n}!` : "¡Qué gusto contar contigo!",
    "Rogelio | Roge by Human RMSA",
  ].filter((l) => l !== null).join("\n");
}

export function waEnvio(celular, texto) {
  let d = (celular || "").replace(/\D/g, "");
  if (d.length === 10) d = "57" + d;
  return d ? `https://api.whatsapp.com/send?phone=${d}&text=${encodeURIComponent(texto)}` : `https://api.whatsapp.com/send?text=${encodeURIComponent(texto)}`;
}
